import milestoneService from 'resources/milestone/milestone.service';
import { deleteAllMilestoneTasks } from 'resources/task/workflows/deleteAllMilestoneTasks';

export const deleteMilestone = async (milestoneId) => {
  // Delete all tasks first
  await deleteAllMilestoneTasks(milestoneId);
  
  // Then delete the milestone
  const deletedMilestone = await milestoneService.remove({ id: milestoneId });
  return deletedMilestone.data;
};
